// client/src/modules/fleet/index.ts
import type { ModuleManifest } from '../types';
import { routes } from './routes';
import { navItems } from './nav';

/**
 * Assets module manifest (P7)
 *
 * Universal asset management — inventory, compliance, inspections,
 * and task tracking for field service operations.
 */
export const fleetModule: ModuleManifest = {
  id: 'P7',
  name: 'Assets',
  shortName: 'Assets',
  description: 'Universal asset management — inventory, compliance, inspections, and task tracking',
  icon: '📦',
  status: 'live',
  urlPrefix: '/assets',
  routes,
  navItems,
  collections: {
    FLEET_VEHICLES: 'fleetVehicles',
    FLEET_INSPECTIONS: 'fleetInspections',
    FLEET_DEFECTS: 'fleetDefects',
    FLEET_MILEAGE_LOGS: 'fleetMileageLogs',
    ASSET_CATEGORIES: 'assetCategories',
    ASSETS: 'assets',
  },
};

export default fleetModule;
